"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_SEO_CONTAINER_GROUP_KEY = void 0;
exports.groupAppSeo = groupAppSeo;
exports.groupAppSeoFromConfig = groupAppSeoFromConfig;
const app_page_exposure_1 = require("./app-page-exposure");
exports.APP_SEO_CONTAINER_GROUP_KEY = 'container';
function groupAppSeo(input) {
    const mounts = new Map(input.mounts.map(mount => [mount.mountId, mount]));
    const groups = new Map();
    for (const page of input.pages) {
        if (!input.indexable(page.path))
            continue;
        const route = input.routeSeo.find(item => item.routePath === page.path);
        const mount = route?.owner.kind === 'app' ? mounts.get(route.owner.mountId) : undefined;
        const group = mount
            ? {
                key: mount.mountId,
                title: mount.navigationLabel ?? input.appTitle(mount.appId) ?? mount.appId,
                order: mount.order,
            }
            : {
                key: exports.APP_SEO_CONTAINER_GROUP_KEY,
                title: input.containerTitle,
                order: -1,
            };
        const entry = groups.get(group.key) ?? { ...group, pages: [] };
        if (route?.strategy !== 'internalRoute')
            entry.pages.push(page);
        groups.set(group.key, entry);
    }
    return [...groups.values()]
        .sort((a, b) => a.order - b.order)
        .map(group => ({
        key: group.key,
        title: group.title,
        pageIds: group.pages.map(page => page.id),
        never: group.pages.length === 0,
        indexed: group.pages.length > 0 &&
            group.pages.every(page => page.seoIndexing !== false),
    }));
}
function groupAppSeoFromConfig(appBaseConfig, containerTitle) {
    const routes = appBaseConfig.appBase?.routes ?? [];
    return groupAppSeo({
        pages: appBaseConfig.pages,
        indexable: path => {
            const route = routes.find(candidate => candidate.path === path);
            return route !== undefined && (0, app_page_exposure_1.appPageIndexable)({ appBaseConfig, route });
        },
        routeSeo: appBaseConfig.appArtifact?.manifest.routeSeo ?? [],
        mounts: appBaseConfig.appComposition?.mounts ?? [],
        appTitle: appId => appBaseConfig.appDefinitions[appId]?.title,
        containerTitle,
    });
}
